<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Relatório Caixa Mensal</h3>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs3 text-xs-right>
        <v-switch
          :label="`${pesquisaModel.ativo ? 'Unidade' : 'Todas Unidades'}`"
          v-model="pesquisaModel.ativo"
          :disabled="usuarioLogado.idtipousuario != perfilUsr.ID.administrador"
          color="primary"
          @change="buscarDados()"
        ></v-switch>
      </v-flex>
      <v-flex xs12 md4 text-xs-right>
        <v-text-field
          label="Pesquisar"
          v-model="filtro"
          color="secondary"
          append-icon="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-layout row wrap>
        <v-flex xs12 lg3>
          <v-card color="purple" class="white--text">
            <v-card-title primary-title>
              <div>
                <div class="headline">Total em caxia</div>
                <span class="subheading mr-2">{{
                  valorCaixa.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}</span>
                <br />
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 lg3>
          <v-card color="red" class="white--text">
            <v-card-title primary-title>
              <div>
                <div class="headline">Total em descontos</div>
                <span class="subheading mr-2">{{
                  valorDescontos.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}</span>
                <br />
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 lg3>
          <v-card color="blue" class="white--text">
            <v-card-title primary-title>
              <div>
                <div class="headline">Total em produtos</div>
                <span class="subheading mr-2">{{
                  valorProdutos.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}</span>
                <br />
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 lg3>
          <v-card color="green" class="white--text">
            <v-card-title primary-title>
              <div>
                <div class="headline">Total em lucro</div>
                <span class="subheading mr-2">{{
                  valorLucro.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}</span>
                <br />
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-card class="default-border" flat>
          <v-data-table
            :headers="headers"
            :items="listaInfo"
            class="elevation-1"
            :search="filtro"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.data }}</td>
              <td>
                {{
                  props.item.valorCaixa.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{
                  props.item.valorDescontos.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{
                  props.item.valorProdutos.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{
                  props.item.valorLucro.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ props.item.numeroVendas }}
              </td>
              <td>
                {{
                  (
                    props.item.valorCaixa / props.item.numeroVendas
                  ).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{ props.item.conta }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="3200"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      v-model="snackbarModel.mostrar"
      bottom
      multi-line
    >
      {{ snackbarModel.text }}
      <v-btn dark flat @click.native="snackbarModel.mostrar = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import usuarioHelper from "@/helpers/usuario.js";
import cipher from "@/helpers/cipher.js";
import perfil from "@/helpers/perfil.js";
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";

export default {
  name: "CaixaMensal",
  data: () => ({
    snackbarModel: {
      mostrar: false,
      sucesso: false,
      text: "",
    },
    pesquisaModel: {
      ativo: true,
    },
    valorCaixa: 0.0,
    valorDescontos: 0.0,
    valorProdutos: 0.0,
    valorLucro: 0.0,
    filtro: "",
    pagination: { rowsPerPage: 20 },
    headers: [
      { text: "Mês-Ano", value: "data", sortable: false },
      { text: "Valor em caixa", value: "valorCaixa", sortable: false },
      { text: "Valor dado em desconto", value: "valorDescontos", sortable: false },
      { text: "Valor em produtos", value: "valorProdutos", sortable: false },
      { text: "Lucro", value: "valorLucro", sortable: false },
      { text: "Nº Vendas", value: "numeroVendas", sortable: false },
      { text: "Ticket Médio", value: "", sortable: false },
      { text: "Unidade", value: "conta" },
    ],
    listaInfo: [],
  }),
  mounted: function () {
    this.buscarDados();
    this.externalSnackbarMessage();
  },
  computed: {
    customFormatComputed: function () {
      return customFormat;
    },
    cipherComputed: function () {
      return cipher;
    },
    perfilUsr: function () {
      return perfil;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
  },
  methods: {
    buscarDados: function () {
      const self = this;

      self.valorCaixa = 0.0;
      self.valorDescontos = 0.0;
      self.valorProdutos = 0.0;
      self.valorLucro = 0.0;

      if (self.pesquisaModel.ativo) {
        self.$http
          .get(
            `${process.env.URL_API}/contasreceber/v1/busca/relatoriomensal/conta/` +
              jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaInfo = response.data;
            self.listaInfo.forEach((e) => {
              self.valorCaixa = e.valorCaixa + self.valorCaixa;
              self.valorDescontos = e.valorDescontos + self.valorDescontos;
              self.valorProdutos = e.valorProdutos + self.valorProdutos;
              self.valorLucro = e.valorLucro + self.valorLucro;
            });
          });
      } else {
        self.$http
          .get(
            `${process.env.URL_API}/contasreceber/v1/busca/relatoriomensal/conta/` +
              0,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaInfo = response.data;
            self.listaInfo.forEach((e) => {
              self.valorCaixa = e.valorCaixa + self.valorCaixa;
              self.valorDescontos = e.valorDescontos + self.valorDescontos;
              self.valorProdutos = e.valorProdutos + self.valorProdutos;
              self.valorLucro = e.valorLucro + self.valorLucro;
            });
          });
      }
    },
    goEdit: function (id) {
      const self = this;
      self.$router.push({ name: "CadastroConta", params: { id: id } });
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbarModel.sucesso = self.$route.params.snackbarSucesso;
        self.snackbarModel.text = self.$route.params.snackbarText;
        self.snackbarModel.mostrar = self.$route.params.snackbarMostrar;
      }
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/relatorio/CaixaMensal.vue